<template>
  <v-container>
      <v-layout row>
          <v-flex xs12 sm6 offset-sm3>
            <v-card width="400" class="mx-auto mt-15">
              <v-card-text>
                <v-text-field
                  v-bind:label="$t('username')"
                  v-model="loginUser.username"
                  type="text"
                  @keyup.enter="login()"
                  required />
              
                <v-text-field
                  v-bind:label="$t('password')"
                  v-model="loginUser.password"
                  :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @keyup.enter="login()"
                  @click:append="showPassword = !showPassword"
                  required />
                <v-btn type="submit" @click="login()">{{ $t('login') }}</v-btn>                
                <div class="message">{{ message }}</div>

              </v-card-text>
            </v-card>
          </v-flex>
      </v-layout>
  </v-container>
</template>
<script>
export default {
  data()
  {
      return{
          showPassword: false,
          message: '',
          loginUser:{
            username: "",
            password: "",
          },
      }
  },
  methods: {

    login: function() {
      let username = this.loginUser.username;
      let password = this.loginUser.password;
      if (!(username && password)){
        this.message = this.$t('usernamePasswordRequired');
        return;
      }
      this.message = '';
      this.$store.dispatch('login', {user: {username, password}, authType: this.$config.AuthConfigType})
        .then(() => {
          this.$router.push('/')
        })
        .catch(err => {
          this.message = err
          console.log(err)
        })
      }
  }
}

</script>

<style scoped>
.message {
  margin-top: 5px;
  color:red;
}
</style>